import type { Locale } from 'date-fns'
import * as dateFns from 'date-fns'
import { ru } from 'date-fns/locale'

declare module 'nuxt/app' {
  interface NuxtApp {
    $dateFns: typeof dateFns
  }
}

export default defineNuxtPlugin({
  name: 'date-fns:plugin',
  dependsOn: ['alt-container:plugin'],
  setup() {
    const dateFnsLocales: Record<string, Locale> = {
      ru,
    }

    const dateObj = { ...dateFns }

    function mergeOptions(options?: any) {
      if (!options) {
        options = {}
      }
      options.locale = dateFnsLocales.ru
      return options
    }

    dateObj.formatDistance = (date, baseDate, options) => {
      return dateFns.formatDistance(date, baseDate, mergeOptions(options))
    }

    dateObj.formatDistanceStrict = (date, baseDate, options) => {
      return dateFns.formatDistanceStrict(date, baseDate, mergeOptions(options))
    }

    dateObj.format = (date, format, options) => {
      return dateFns.format(date, format, mergeOptions(options))
    }

    dateObj.formatRelative = (date, baseDate, options) => {
      return dateFns.formatRelative(date, baseDate, mergeOptions(options))
    }

    return {
      provide: {
        dateFns: dateObj,
      },
    }
  },
})
